<script lang="ts" setup>
import { useNavButton } from './composables/useNavButton'
import InvestorSubMenu from '@/domains/investor/components/SubMenu/SubMenu.vue'

const { locale } = useI18n()
const lang = computed(() => locale.value)
useNavButton()

useHead({
  htmlAttrs: {
    'data-layout': 'investor',
  },
})
</script>

<template>
  <Html :lang="lang">
    <Body class="investor-page">
      <UiNavigation :sticking="false" />

      <InvestorSubMenu />

      <main class="main">
        <slot />
      </main>

      <UiFooter />
    </Body>
  </Html>
</template>

<style lang="scss">
.investor-page {
  @include atM {
    .navigation {
      background-color: $white;
      box-shadow: 0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
